// extracted by mini-css-extract-plugin
module.exports = {"Page":"style_Page__2xn7s","Page_hide":"style_Page_hide__g1uwl","Content":"style_Content__1NBp0","Title":"style_Title__ttRDp"};